var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":"/dashboard"}},[_vm._v("Dashboard ")]),_vm._v(" --------- "),_c('router-link',{attrs:{"to":"/editor"}},[_vm._v(" Editor")]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }